import React, { useEffect, useState, useMemo, Fragment } from 'react';
import { Stack } from '@mui/system';
import { useScreen } from 'common/hooks/useScreen';
import { RedTheme } from 'common/global';
import { fontWeightStyles } from 'TAP/styles/genericStyles/fontWeights';
import { Box, Typography, Grid, Button } from '@mui/material';
import { CurriCulumAdditionDisclaimer } from 'TAP/components/UserGroupProfile/CurriCulumAdditionDisclaimer';
import {
  NUMBER_ARRAY,
  PAGE_SIZES_ARRAY_GENERIC,
  USER_PROFILE_LABELS,
} from 'common/global/constants';
import { width } from 'TAP/styles/genericStyles/width';
import { height } from 'TAP/styles/genericStyles/height';
import { useDispatch, useSelector } from 'react-redux';
import {
  MyTeamProfileSave,
  MyTeamProfileTableData,
  MyTeamProfileReset,
  GetMyTeamProfileFilterData,
} from 'TAP/redux/actions/UserProfileActions/myTeamProfileAction';
import { TapGlobalMessages } from 'TAP/global';
import GenericDataGridTable from 'TAP/components/UserGroupProfile/GenericDataGrid';
import { ToolTipWrapper } from 'common/components';
import { GenericPopUpUserProfile } from 'TAP/components/UserGroupProfile/GenericPopUpUserProfile';
import { MyTeamProfilePopUpUserProfile } from 'TAP/components/UserGroupProfile/MyTeamProfilePopUpUserProfile';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MyTeamProfileFilters from 'TAP/components/UserGroupProfile/MyTeamProfileFilter';
import { ShowLoader } from 'TAP/global/showLoader';
import { ReactComponent as Download } from 'common/assets/images/DownLoad.svg';
import { Toaster } from 'TAP/components/Toaster';
import { EllipsisTypography } from 'TAP/components/UserGroupProfile/EllipsisTypography';
import MyTeamProfileReadOnlyPopupUserProfile from 'TAP/components/UserGroupProfile/MyTeamProfileReadOnlyPopupUserProfile';
import { incrementPollingCount } from 'TAP/redux/actions/downloadPollingAction';
import { DownloadStartPopup } from 'common/components/downloadStartPopup';
import { AdminDownloadData } from 'TAP/redux/actions';
const containerPadding = {
  mobile: '16px',
  tablet: '0 24px 24px 24px',
  desktop: '16px 72px 0 72px',
};

export const MyTeamProfile = ({ handleCloseDisclaimer, isDisclaimerToShow }) => {
  const screen = useScreen();
  const redtheme = RedTheme;

  const parentContainerStyle = {
    background: redtheme.palette.background.default,
    display: 'flex',
    width: '100%',
    padding: screen.resolveStyles(containerPadding),
    flexDirection: 'column',
    height: '100%',
  };

  const btnStyle = {
    bgcolor: redtheme.palette.button.pure_red,
    color: redtheme.palette.button.white,
    padding: '8px, 16px, 8px, 16px',
    borderRadius: '10px',
    gap: '10px',
    textTransform: 'none',
    fontWeight: NUMBER_ARRAY.fiveHundred,
    fontSize: '16px',
    width: '124px',
    height: '32px',
    fontFamily: '"JohnsonText-Light"',
    '&:focus': { outline: 'none' },
    lineHeight: '29px',
  };

  const myTeamProfileTableData = useSelector(
    (state) => state?.myTeamProfileRd?.teamProfileTableData?.data,
  );
  const myTeamProfileSaveResponse = useSelector(
    (state) => state?.myTeamProfileRd?.saveResponse?.data,
  );
  const myTeamProfileFilterData = useSelector(
    (state) => state?.myTeamProfileRd?.myTeamFilterData?.data,
  );
  const [logInUserDetails, setLogInUserDetails] = useState('');
  const [initializer, setInitializer] = useState(false);
  const [gridRows, setGridRows] = useState([]);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalTitleSubHeader, setModalTitleSubHeader] = useState('');
  const [rowId, setRowId] = useState('');
  const [savePayloadObj, setSavePayLoadObj] = useState(null);
  const [isSaveDisable, setSaveDisable] = useState(false);
  const [wwidOptions, setWwidOptions] = useState([]);
  const [partnerCompanyOptions, setPartnerCompanyOptions] = useState([]);
  const [workerTypeOptions, setWorkerTypeOptions] = useState([]);
  const [selectedWWID, setSelectedWWID] = useState([]);
  const [selectedPartnerCompanyValue, setSelectedPartnerCompanyValue] = useState([]);
  const [selectedWorkerTypeValue, setSelectedWorkerTypeValue] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [showLargeDataDownloadSuccessMsg, setShowLargeDataDownloadSuccessMsg] = useState(false);
  const [largeDataDownloadMsg, setLargeDataDownloadMsg] = useState('');
  const [downloadToasterSeverity, setDownloadToasterSeverity] = useState('Download Successfully !');
  const MyTeamProfile100KDownloadDetailsRd = useSelector(
    (state) => state?.MyTeamProfile100KDownloadDetailsRd?.MyTeamProfile100KDownloadDetailsRd?.data,
  );
  const USER = 'User';
  const PARTNER_COMPANY = 'Partner_Company';
  const WORKER_TYPE = 'Worker_Type';
  const [isSaveSuccessMessage, setIsSaveSuccessMessage] = useState(false);
  const [isRequiredValidation, setIsRequiredValidation] = useState(false);
  const [isShowValidationMsg, setIsShowValidationMsg] = useState(false);
  const [openReadOnlyPopup, setOpenReadOnlyPopup] = useState(false);
  const [isShowWarningReadonlyPopUp, setIsShowWarningReadonlyPopUp] = useState(false);

  const dispatch = useDispatch();

  const userDetails = localStorage.getItem('userDetails');

  const handleRowCLick = (params) => {
    //logic here
    const isOneSupplier = params.row.isOneSupplier;
    if (isOneSupplier) {
      setOpenReadOnlyPopup(isOneSupplier);
      setIsShowWarningReadonlyPopUp(isOneSupplier);
    } else {
      setIsPopUpOpen(true);
    }
    setModalTitle(`${params?.row?.full_name || ''}`);
    setModalTitleSubHeader(`${params.id}`);
    setRowId(params.id);
  };

  const handleSave = (payload, isSaveDisabled, reuiredFieldValidation) => {
    //logic here
    if (reuiredFieldValidation && !isSaveDisabled) {
      setIsRequiredValidation(reuiredFieldValidation);
      setSaveDisable(false);
      return;
    } else {
      setIsRequiredValidation(false);
    }
    payload.wwid = rowId;
    payload.createdByName = logInUserDetails?.full_name;
    payload.createdById = logInUserDetails?.user_id;
    setSavePayLoadObj(payload);
    setSaveDisable(isSaveDisabled);
  };

  const handleClosePopup = () => {
    // logic here
    setIsPopUpOpen(false);
    setIsShowValidationMsg(false);
  };

  const handlePopUpSave = () => {
    //logic here
    if (isRequiredValidation) {
      setIsShowValidationMsg(true);
    } else {
      dispatch(MyTeamProfileSave(savePayloadObj));
      setIsShowValidationMsg(false);
    }
  };

  const renderCustomizeCell = (params, width, fieldName = '') => {
    const twoLineCss = {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'normal !important',
    };
    return (
      <Typography
        sx={[
          {
            fontStyle: 'normal',
            fontWeight: fontWeightStyles.fw5.fontWeight,
            fontSize: '11px',
            lineHeight: '18px',
            fontFamily: '"JohnsonText-Medium"',
            color: redtheme.palette.fontColor.black_gray,
            cursor: params.value ? 'pointer' : 'not-allowed',
            width: width,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
          fieldName === 'job_role' && twoLineCss,
        ]}
        onClick={() => {
          handleRowCLick(params);
        }}
      >
        {params?.value}
      </Typography>
    );
  };

  const renderHeadersTooltip = (title, Header) => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography sx={{ fontFamily: '"JohnsonText-Bold"' }}>{Header}</Typography>
        <ToolTipWrapper
          title={title}
          placement='top'
          isOnlyText={true}
          isCustomHtmlTooltip={true}
          tooltipCss={{
            padding: '4px 8px',
          }}
        >
          <HelpOutlineIcon
            sx={{
              '&.MuiSvgIcon-root': {
                height: '12px',
                width: '12px',
                color: `${redtheme.palette.common.primaryMainBlue}`,
                marginTop: '6px',
                marginLeft: '1px',
              },
            }}
          />
        </ToolTipWrapper>
      </Box>
    );
  };

  const renderRowTooltip = (title) => {
    return (
      <Fragment>
        <ToolTipWrapper
          title={title}
          placement='top'
          isOnlyText={true}
          isCustomHtmlTooltip={true}
          tooltipCss={{
            padding: '4px 8px',
          }}
        >
          <HelpOutlineIcon
            sx={{
              '&.MuiSvgIcon-root': {
                height: '12px',
                width: '12px',
                color: `${redtheme.palette.common.primaryMainBlue}`,
                marginTop: '2px',
                marginLeft: '2px',
              },
            }}
          />
        </ToolTipWrapper>
      </Fragment>
    );
  };

  const findRowRecord = useMemo(() => {
    if (myTeamProfileTableData) {
      const row = myTeamProfileTableData.records.find((rec) => rec.user_id === rowId);
      return row;
    }
  }, [rowId, myTeamProfileTableData]);

  const columns = [
    {
      field: 'full_name',
      width: width.wid200,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <Box>
            <Stack sx={{ display: 'flex', flexDirection: 'column' }}>
              <Stack display={'flex'} flexDirection={'row'}>
                <EllipsisTypography
                  title={params?.value}
                  TypographyElement={renderCustomizeCell(params, '100%')}
                  maxWidth={width.wid215}
                />
                {params.row.isOneSupplier &&
                  renderRowTooltip(
                    TapGlobalMessages.userGroupProfile.myTeamProfile.toolTip.oneSupplyUser,
                  )}
              </Stack>
              <Stack display={'flex'}>
                <Typography
                  sx={{
                    fontStyle: 'normal',
                    fontWeight: fontWeightStyles.fw5.fontWeight,
                    fontSize: '14px',
                    lineHeight: '18px',
                    fontFamily: '"JohnsonText-Light"',
                    color: redtheme.palette.fontColor.dark_grayish_orange,
                    marginRight: '50px',
                  }}
                >
                  {params.id}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        );
      },
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontFamily: '"JohnsonText-Bold"' }}>Users</Typography>
          <Typography
            sx={{
              fontFamily: '"JohnsonText-Bold"',
              color: redtheme.palette.fontColor.gray,
            }}
          >
            WWID
          </Typography>
        </Box>
      ),
    },
    {
      field: 'job_role',
      width: width.wid150,
      headerAlign: 'left',
      align: 'left',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontFamily: '"JohnsonText-Bold"' }}>Role</Typography>
        </Box>
      ),
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid150, 'job_role')}
            maxWidth={width.wid130}
          />
        );
      },
    },
    {
      field: 'organization',
      width: width.wid160,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid160)}
            maxWidth={width.wid160}
          />
        );
      },
      renderHeader: () =>
        renderHeadersTooltip(
          TapGlobalMessages.userGroupProfile.myProfile.toolTip.organization,
          'Organization',
        ),
    },
    {
      field: 'function',
      width: width.wid130,
      headerAlign: 'left',
      align: 'left',
      renderHeader: () =>
        renderHeadersTooltip(
          TapGlobalMessages.userGroupProfile.myProfile.toolTip.function,
          'Function',
        ),
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid130)}
            maxWidth={width.wid130}
          />
        );
      },
    },
    {
      field: 'sub_function',
      width: width.wid160,
      headerAlign: 'left',
      align: 'left',
      renderHeader: () =>
        renderHeadersTooltip(
          TapGlobalMessages.userGroupProfile.myProfile.toolTip.subFunction,
          'Sub Function',
        ),
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid160)}
            maxWidth={width.wid160}
          />
        );
      },
    },
    {
      field: 'specialization',
      width: width.wid175,
      headerAlign: 'left',
      align: 'left',
      renderHeader: () =>
        renderHeadersTooltip(
          TapGlobalMessages.userGroupProfile.myProfile.toolTip.specialization,
          'Specialization',
        ),
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid175)}
            maxWidth={width.wid175}
          />
        );
      },
    },
    {
      field: 'sub_specialization',
      width: width.wid220,
      headerAlign: 'left',
      align: 'left',
      renderHeader: () =>
        renderHeadersTooltip(
          TapGlobalMessages.userGroupProfile.myProfile.toolTip.subSpecialization,
          'Sub Specialization',
        ),
      renderCell: (params) => {
        return (
          <EllipsisTypography
            title={params?.value}
            TypographyElement={renderCustomizeCell(params, width.wid200)}
            maxWidth={width.wid200}
          />
        );
      },
    },
  ];

  const handleAutoCompleteChange = (_event, newValue, type) => {
    if (type === USER) {
      setSelectedWWID(newValue);
      setIsInitialized(true);
      if (newValue === null) {
        setIsInitialized(true);
        setSelectedWWID([]);
      }
    } else if (type === PARTNER_COMPANY) {
      setSelectedPartnerCompanyValue(newValue);
      setIsInitialized(true);
      if (newValue === null) {
        setIsInitialized(true);
        setSelectedPartnerCompanyValue([]);
      }
    } else if (type === WORKER_TYPE) {
      setSelectedWorkerTypeValue(newValue);
      setIsInitialized(true);
      if (newValue === null) {
        setIsInitialized(true);
        setSelectedWorkerTypeValue([]);
      }
    }
  };

  const handleCloseReadOnlyPopup = () => {
    setOpenReadOnlyPopup(false);
    setIsShowWarningReadonlyPopUp(false);
  };

  const [downloadStartPopup, setDownloadStartPopup] = useState(false);
  const handleDownloadClick = () => {
    const payload = {
      userField:
        selectedWWID && selectedWWID.length > NUMBER_ARRAY.zero ? JSON.stringify(selectedWWID) : '',
      managerField: '',
      partnerCompany:
        selectedPartnerCompanyValue && selectedPartnerCompanyValue.length > NUMBER_ARRAY.zero
          ? JSON.stringify(selectedPartnerCompanyValue)
          : '',
      workerType:
        selectedWorkerTypeValue && selectedWorkerTypeValue.length > NUMBER_ARRAY.zero
          ? JSON.stringify(selectedWorkerTypeValue)
          : '',
      country: '',
      isHierarchyOn: 0,
      days: 7,
      trainingTitle: '',
      dataOf: '',
      mrc: '',
      legalEntityName: '',
      userArray: '',
      exclUserArray: '',
      courseCode: '',
    };

    setDownloadStartPopup(true);
    dispatch(AdminDownloadData({ ...payload, reportType: 'myteamsProfile' })).then(() => {
      setTimeout(() => {
        dispatch(incrementPollingCount());
      }, 5000);
    });
  };

  useEffect(() => {
    if (myTeamProfileTableData) {
      setGridRows(myTeamProfileTableData.records);
    }
  }, [myTeamProfileTableData]);

  useEffect(() => {
    if (myTeamProfileSaveResponse === 'Data Saved successfully!') {
      const payloadUserLogedIn = {
        loggedInUserId: logInUserDetails?.user_id,
        userIdNameArray: '',
        partner_company: '',
        worker_type: '',
      };
      setIsSaveSuccessMessage(true);
      handleClosePopup();
      dispatch(MyTeamProfileTableData(payloadUserLogedIn));
      dispatch(MyTeamProfileReset());
    }
  }, [myTeamProfileSaveResponse]);

  useEffect(() => {
    if (!initializer) {
      if (userDetails && Object.keys(userDetails).length) {
        setLogInUserDetails(JSON.parse(userDetails));
      }
      setInitializer(true);
    }
  }, [initializer, userDetails]);

  useEffect(() => {
    if (logInUserDetails) {
      const payloadUserLogedIn = {
        loggedInUserId: logInUserDetails?.user_id,
        userIdNameArray: '',
        partner_company: '',
        worker_type: '',
      };
      dispatch(MyTeamProfileTableData(payloadUserLogedIn));
    }
  }, [logInUserDetails]);

  useEffect(() => {
    if (logInUserDetails) {
      let payload = {
        loggedInUserId: logInUserDetails?.user_id,
      };
      dispatch(GetMyTeamProfileFilterData(payload));
    }
  }, [logInUserDetails]);

  useEffect(() => {
    if (myTeamProfileFilterData) {
      setWwidOptions(myTeamProfileFilterData.userIdNameArray);
      setPartnerCompanyOptions(myTeamProfileFilterData.partner_company);
      setWorkerTypeOptions(myTeamProfileFilterData.worker_type);
    }
  }, [myTeamProfileFilterData]);

  //Filter by WWID
  useEffect(() => {
    if (isInitialized) {
      const payloadUserLogedIn = {
        loggedInUserId: logInUserDetails?.user_id,
        userIdNameArray:
          selectedWWID && selectedWWID.length > NUMBER_ARRAY.zero ? selectedWWID : '',
        partner_company:
          selectedPartnerCompanyValue && selectedPartnerCompanyValue.length > NUMBER_ARRAY.zero
            ? selectedPartnerCompanyValue
            : '',
        worker_type:
          selectedWorkerTypeValue && selectedWorkerTypeValue.length > NUMBER_ARRAY.zero
            ? selectedWorkerTypeValue
            : '',
      };
      dispatch(MyTeamProfileTableData(payloadUserLogedIn));
    }
  }, [selectedWWID]);

  //Filter by Partner Company
  useEffect(() => {
    if (isInitialized) {
      const payloadUserLogedIn = {
        loggedInUserId: logInUserDetails?.user_id,
        userIdNameArray:
          selectedWWID && selectedWWID.length > NUMBER_ARRAY.zero ? selectedWWID : '',
        partner_company:
          selectedPartnerCompanyValue && selectedPartnerCompanyValue.length > NUMBER_ARRAY.zero
            ? selectedPartnerCompanyValue
            : '',
        worker_type:
          selectedWorkerTypeValue && selectedWorkerTypeValue.length > NUMBER_ARRAY.zero
            ? selectedWorkerTypeValue
            : '',
      };
      dispatch(MyTeamProfileTableData(payloadUserLogedIn));
    }
  }, [selectedPartnerCompanyValue]);

  //Filter by Worker Type
  useEffect(() => {
    if (isInitialized) {
      const payloadUserLogedIn = {
        loggedInUserId: logInUserDetails?.user_id,
        userIdNameArray:
          selectedWWID && selectedWWID.length > NUMBER_ARRAY.zero ? selectedWWID : '',
        partner_company:
          selectedPartnerCompanyValue && selectedPartnerCompanyValue.length > NUMBER_ARRAY.zero
            ? selectedPartnerCompanyValue
            : '',
        worker_type:
          selectedWorkerTypeValue && selectedWorkerTypeValue.length > NUMBER_ARRAY.zero
            ? selectedWorkerTypeValue
            : '',
      };
      dispatch(MyTeamProfileTableData(payloadUserLogedIn));
    }
  }, [selectedWorkerTypeValue]);

  useEffect(() => {
    if (MyTeamProfile100KDownloadDetailsRd !== undefined) {
      setShowLargeDataDownloadSuccessMsg(false);
      setDownloadToasterSeverity('warn');
      setLargeDataDownloadMsg(TapGlobalMessages.largeDownloadStartMsg);
    }
  }, [MyTeamProfile100KDownloadDetailsRd]);

  return (
    <Box sx={parentContainerStyle}>
      <ShowLoader></ShowLoader>
      {isDisclaimerToShow && (
        <CurriCulumAdditionDisclaimer
          handleClose={handleCloseDisclaimer}
          spacing={0.65}
          innerWidth={screen.resolveStyles({ mobile: '100%', desktop: '490px' }, 'mobile')}
          contentHeight={screen.resolveStyles({ mobile: 'auto', desktop: '46px' }, 'mobile')}
          contentPadding={screen.isTablet && '8px 0'}
        />
      )}
      <Grid item xs={12} sx={{ marginTop: screen.isDesktop ? '30px' : '0px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '20px',
          }}
        >
          <MyTeamProfileFilters
            wwidOptions={wwidOptions}
            onWWIDChange={(event, value) => handleAutoCompleteChange(event, value, USER)}
            partnerOptions={partnerCompanyOptions}
            onPartnerCompanyChange={(event, value) =>
              handleAutoCompleteChange(event, value, PARTNER_COMPANY)
            }
            workerTypeOptions={workerTypeOptions}
            onWorkerTypeChange={(event, value) =>
              handleAutoCompleteChange(event, value, WORKER_TYPE)
            }
            wwidValues={selectedWWID}
            partnerCompanyValues={selectedPartnerCompanyValue}
            workerTypeValues={selectedWorkerTypeValue}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              onClick={handleDownloadClick}
              variant='contained'
              sx={btnStyle}
              data-testid='download'
            >
              <Download /> {'Download'}
            </Button>
            <ToolTipWrapper
              title={TapGlobalMessages.userGroupProfile.myTeamProfile.toolTip.downloadButton}
              placement='top'
              header='How Excel Works?'
            >
              <HelpOutlineIcon
                fontSize='medium'
                sx={{
                  color: `${redtheme.palette.common.primaryMainBlue}`,
                  height: '25px',
                  width: '25px',
                  marginTop: '4px',
                  marginLeft: '5px',
                }}
              />
            </ToolTipWrapper>
          </Box>
        </Box>
        <Toaster
          onClose={() => setShowLargeDataDownloadSuccessMsg(false)}
          hideDuration={NUMBER_ARRAY.thirtyThousand}
          severity={downloadToasterSeverity}
          show={showLargeDataDownloadSuccessMsg}
          message={largeDataDownloadMsg}
        />
        <GenericDataGridTable
          gridColumns={columns}
          gridHeight={height.h445}
          gridWidth={width.wid1200}
          pageSize={5}
          gridRows={gridRows}
          pageSizeOptions={PAGE_SIZES_ARRAY_GENERIC}
          gridRowHeight={height.h64}
          sortingMode={'client'}
          paginationMode={'client'}
          disableColumnMenuProp={true}
          hideSelectedRowCount={true}
          sortingDefaultColumn={'full_name'}
          sortingDefaultColumnMode={'asc'}
        />
      </Grid>
      <GenericPopUpUserProfile
        open={isPopUpOpen}
        onClose={handleClosePopup}
        onConfirm={handlePopUpSave}
        title={modalTitle}
        disableSaveButton={isSaveDisable}
        titleSubHeader={modalTitleSubHeader}
        rightButtonText={USER_PROFILE_LABELS.rightButtonText}
        leftButtonText={USER_PROFILE_LABELS.leftButtonText}
      >
        {myTeamProfileTableData && (
          <Fragment>
            <Stack className='pop-up-user-profile'>
              {isShowValidationMsg && (
                <Grid container>
                  <Grid item md={12} className='other-warning-toaster'>
                    <Toaster
                      onClose={() => setIsShowValidationMsg(false)}
                      vertical={'bottom'}
                      hideDuration={NUMBER_ARRAY.thirtyThousand}
                      severity={'warn'}
                      show={isShowValidationMsg}
                      message={TapGlobalMessages.userGroupProfile.reuiredFieldValidationMessage}
                    />
                  </Grid>
                </Grid>
              )}
            </Stack>
            <MyTeamProfilePopUpUserProfile params={findRowRecord} saveCallBack={handleSave} />
          </Fragment>
        )}
      </GenericPopUpUserProfile>
      <GenericPopUpUserProfile
        open={openReadOnlyPopup}
        onClose={handleCloseReadOnlyPopup}
        title={modalTitle}
        disableSaveButton={isSaveDisable}
        titleSubHeader={modalTitleSubHeader}
        rightButtonText={USER_PROFILE_LABELS.rightButtonTextOk}
        leftButtonText={USER_PROFILE_LABELS.leftButtonTextCancel}
        onConfirm={handleCloseReadOnlyPopup}
      >
        {myTeamProfileTableData && (
          <Fragment>
            <Stack className='pop-up-user-profile'>
              {isShowWarningReadonlyPopUp && (
                <Grid container>
                  <Grid item md={12} className='other-warning-toaster'>
                    <Toaster
                      onClose={() => setIsShowWarningReadonlyPopUp(false)}
                      vertical={'bottom'}
                      hideDuration={NUMBER_ARRAY.thirtyThousand}
                      severity={'warn'}
                      show={isShowWarningReadonlyPopUp}
                      message={
                        TapGlobalMessages.userGroupProfile.myTeamProfile.toolTip.oneSupplyUser
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </Stack>
            <MyTeamProfileReadOnlyPopupUserProfile params={findRowRecord} />
          </Fragment>
        )}
      </GenericPopUpUserProfile>
      <Toaster
        onClose={() => setIsSaveSuccessMessage(false)}
        hideDuration={NUMBER_ARRAY.fiveThousand}
        severity={'success'}
        show={isSaveSuccessMessage}
        message={TapGlobalMessages.userGroupProfile.savedSuccessMessage}
      />
      <DownloadStartPopup open={downloadStartPopup} onClose={() => setDownloadStartPopup(false)} />
    </Box>
  );
};
